$(function () {
    $('.secure-link-component')
        .on('overwrite-additional-data', function (event, additionalData) {
            $(this).find('input[type="hidden"].additional-data').each(function() {
                $(this).val(additionalData[$(this).attr('name')] ?? $(this).val());
            });
        });
    $(document).on('click', ".secure-link-component [href]", function (event) {
        event.preventDefault();

        const $a = $(event.currentTarget);

        if (!$a.hasClass('sweet-alert-popup')) {
            submitSecureLinkForm($a);
        }
    })
})

export function submitSecureLinkForm(element) {
    const secureClass = 'secured';
    const $el = $(element);

    if ($el.hasClass(secureClass) || $el.children().hasClass(secureClass)) {
        const $form = $(element).closest('form');
        $form.attr('action', $(element).attr('href'));
        $form.submit();

        return true;
    }

    return false;
}
